import { IValidationRule } from "@/types"

const freightUnitValidationRules: { [s: string]: IValidationRule } = {
    measurementSystemId: {
        required: true
    },
    dimension1: {
        type: "decimal",
        min: 0
    },
    dimension2: {
        type: "decimal",
        min: 0
    },
    dimension3: {
        type: "decimal",
        min: 0
    },
    volume: {
        type: "decimal",
        min: 0
    },
    weight: {
        type: "decimal",
        min: 0
    },
}

export default freightUnitValidationRules
